var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-manager-top bg-light h-100 d-flex flex-column",
      class: { "fullscreen-mode": _vm.fullscreen }
    },
    [
      _c(
        "div",
        {
          staticClass: "py-1 px-4 d-flex w-100 align-items-center",
          staticStyle: { "border-bottom": "1px solid #ccc" }
        },
        [
          _c("h4", { staticClass: "bold" }, [_vm._v("Liste des tâches")]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-auto" }, [
            _vm.fullscreen
              ? _c(
                  "a",
                  {
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        _vm.fullscreen = false
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-size-actual" })]
                )
              : _c(
                  "a",
                  {
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        _vm.fullscreen = true
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon-size-fullscreen" })]
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex task-manager-container w-100 flex-grow-1",
          class: {
            "task-selected": _vm.selectedTask !== null,
            "is-mobile": _vm.isMobile
          },
          staticStyle: { height: "173px" }
        },
        [
          _c(
            "div",
            { staticClass: "position-relative task-manager-left-panel" },
            [
              _c(
                "div",
                {
                  staticClass: "bg-grey py-3 px-4 d-flex task-manager-filters",
                  staticStyle: { "flex-wrap": "wrap" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter-element d-flex align-items-center" },
                    [
                      _c(
                        "label",
                        { staticStyle: { width: "90px", "min-width": "90px" } },
                        [_vm._v("Mots clés:")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.taskFilters.keywords,
                            expression: "taskFilters.keywords"
                          }
                        ],
                        staticClass: "form-control input-sm mx-1",
                        attrs: { type: "text", placeholder: "Mots clés..." },
                        domProps: { value: _vm.taskFilters.keywords },
                        on: {
                          change: _vm.fetchTasks,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.taskFilters,
                              "keywords",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-element d-flex align-items-center" },
                    [
                      _c(
                        "label",
                        { staticStyle: { width: "60px", "min-width": "60px" } },
                        [_vm._v("Ordre:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.taskFilters.order_column,
                              expression: "taskFilters.order_column"
                            }
                          ],
                          staticClass: "form-control input-sm mx-1",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.taskFilters,
                                  "order_column",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.fetchTasks
                            ]
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "task_creation_datetime" } },
                            [_vm._v("Date de création")]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "task_deadline_date" } },
                            [_vm._v("Date d'échéance")]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "task_start_date" } },
                            [_vm._v("Date de début")]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "task_remind_date" } },
                            [_vm._v("Date de rappel")]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "project_number" } }, [
                            _vm._v("Projet")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "task_name" } }, [
                            _vm._v("Nom de la tâche")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.taskFilters.order_direction == "DESC"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm blue",
                              on: {
                                click: function($event) {
                                  _vm.taskFilters.order_direction = "ASC"
                                  _vm.fetchTasks()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-arrow-down" })]
                          )
                        : _vm.taskFilters.order_direction == "ASC"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm blue",
                              on: {
                                click: function($event) {
                                  _vm.taskFilters.order_direction = "DESC"
                                  _vm.fetchTasks()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-arrow-up" })]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-element d-flex align-items-center" },
                    [
                      _c(
                        "label",
                        { staticStyle: { width: "90px", "min-width": "90px" } },
                        [_vm._v("États:")]
                      ),
                      _vm._v(" "),
                      _c("multiselect", {
                        staticClass: "btn btn-default input-sm",
                        attrs: {
                          options: _vm.stateOptions,
                          popupWidth: "250px",
                          width: "200px",
                          optionTemplate: _vm.optionStateTemplate
                        },
                        on: { hidden: _vm.fetchTasks },
                        model: {
                          value: _vm.taskFilters.state_id,
                          callback: function($$v) {
                            _vm.$set(_vm.taskFilters, "state_id", $$v)
                          },
                          expression: "taskFilters.state_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-element d-flex align-items-center" },
                    [
                      _c(
                        "label",
                        { staticStyle: { width: "60px", "min-width": "60px" } },
                        [_vm._v("Projet:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("select2", {
                            ref: "taskFiltersProject",
                            staticClass: "mx-1",
                            attrs: {
                              placeholder: "Tous les projets",
                              endpoint: _vm.projectSelect2Endpoint
                            },
                            on: {
                              selected: _vm.projectSelected,
                              clear: function($event) {
                                return _vm.projectSelected(null)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.options.showUserFilter
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "filter-element d-flex align-items-center"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticStyle: {
                                width: "90px",
                                "min-width": "90px"
                              }
                            },
                            [_vm._v("Utilisateur:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("select2", {
                                staticClass: "mx-1",
                                attrs: {
                                  placeholder: "Tous les utilisateurs",
                                  endpoint: _vm.userSelect2Endpoint,
                                  value: _vm.selectedUserFilter
                                },
                                on: {
                                  selected: _vm.userSelected,
                                  clear: function($event) {
                                    return _vm.userSelected(null)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.options.showUserFilter
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "filter-element d-flex align-items-center"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticStyle: {
                                width: "60px",
                                "min-width": "60px"
                              }
                            },
                            [_vm._v("Assigné:")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.taskFilters.assigned,
                                  expression: "taskFilters.assigned"
                                }
                              ],
                              attrs: { type: "checkbox", value: "1" },
                              domProps: {
                                checked: Array.isArray(_vm.taskFilters.assigned)
                                  ? _vm._i(_vm.taskFilters.assigned, "1") > -1
                                  : _vm.taskFilters.assigned
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.taskFilters.assigned,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "1",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.taskFilters,
                                            "assigned",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.taskFilters,
                                            "assigned",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.taskFilters, "assigned", $$c)
                                    }
                                  },
                                  _vm.fetchTasks
                                ]
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticStyle: {
                                width: "90px",
                                "min-width": "90px"
                              }
                            },
                            [_vm._v("Distribution:")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.taskFilters.distribution,
                                  expression: "taskFilters.distribution"
                                }
                              ],
                              attrs: { type: "checkbox", value: "1" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.taskFilters.distribution
                                )
                                  ? _vm._i(_vm.taskFilters.distribution, "1") >
                                    -1
                                  : _vm.taskFilters.distribution
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.taskFilters.distribution,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "1",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.taskFilters,
                                            "distribution",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.taskFilters,
                                            "distribution",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.taskFilters,
                                        "distribution",
                                        $$c
                                      )
                                    }
                                  },
                                  _vm.fetchTasks
                                ]
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "px-4 py-2",
                  staticStyle: { "border-bottom": "1px solid #ccc" }
                },
                [
                  !_vm.showAddTaskForm
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn blue btn-sm",
                            on: { click: _vm.addNewTask }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" Ajouter une tâche")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn blue btn-sm",
                            attrs: { disabled: _vm.loadingTasks },
                            on: { click: _vm.fetchTasks }
                          },
                          [
                            _c("i", { staticClass: "fa fa-refresh" }),
                            _vm._v(" Rafraîchir ")
                          ]
                        ),
                        _vm._v(" "),
                        _vm.loadingTasks
                          ? _c("img", {
                              staticStyle: {
                                height: "24px",
                                "margin-right": "10px"
                              },
                              attrs: { src: _vm.spinnerSVG }
                            })
                          : _vm._e()
                      ])
                    : _c("div", [
                        _c(
                          "div",
                          { staticClass: "d-flex w-100" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addTaskForm.task_name,
                                  expression: "addTaskForm.task_name"
                                }
                              ],
                              ref: "add-task-name-input",
                              staticClass: "form-control input-sm flex-grow-1",
                              attrs: {
                                type: "text",
                                placeholder: "Nom de la tâche...",
                                disabled: _vm.savingTask
                              },
                              domProps: { value: _vm.addTaskForm.task_name },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.saveNewTask(_vm.addTaskForm)
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    _vm.showAddTaskForm = false
                                  }
                                ],
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.addTaskForm,
                                    "task_name",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("select2", {
                              ref: "taskAddProjectSelect",
                              staticClass: "mx-1",
                              staticStyle: { width: "250px" },
                              attrs: {
                                placeholder: "Projet...",
                                endpoint: _vm.projectSelect2Endpoint
                              },
                              on: { selected: _vm.taskAddProjectSelect },
                              model: {
                                value: _vm.addTaskSelectedProject,
                                callback: function($$v) {
                                  _vm.addTaskSelectedProject = $$v
                                },
                                expression: "addTaskSelectedProject"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm blue",
                                attrs: { disabled: _vm.savingTask },
                                on: {
                                  click: function($event) {
                                    return _vm.saveNewTask(_vm.addTaskForm)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-check" })]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.addTaskError != null
                          ? _c("div", { staticClass: "font-red" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.addTaskError) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "overflow-y": "auto" } }, [
                _vm.loadedTasks.length == 0 && !_vm.loadingTasks
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "text-center p-3 font-grey-gallery" },
                        [_vm._v("Aucune tâches à afficher")]
                      )
                    ])
                  : _c("div", [
                      _c("table", { staticClass: "w-100" }, [
                        _c(
                          "tbody",
                          _vm._l(_vm.loadedTasks, function(task, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                staticClass: "task-manager-task",
                                class: {
                                  selected: task == _vm.selectedTask,
                                  "task-unread": !task.task_read
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectTask(task)
                                  }
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pl-4 py-2",
                                    staticStyle: {
                                      "white-space": "nowrap",
                                      width: "1%"
                                    }
                                  },
                                  _vm._l(task.assignees, function(
                                    assignee,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "task-assignee",
                                        style: {
                                          backgroundColor:
                                            assignee.user_background_color
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(assignee.user_initials) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "py-2 pl-2" }, [
                                  _c("div", { staticClass: "task-name" }, [
                                    _vm._v(_vm._s(task.task_name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "font-size": "11px" } },
                                    [
                                      _vm._v(
                                        _vm._s(task.project_number) +
                                          " • " +
                                          _vm._s(task.project_name)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "font-size": "11px" } },
                                    [
                                      task.task_deadline_date != null
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mr-2 deadline-indicator",
                                              class: {
                                                "deadline-danger":
                                                  _vm.daysBeforeDeadline(task) <
                                                  _vm.options.redIndicatorDays,
                                                "deadline-warning":
                                                  _vm.daysBeforeDeadline(task) <
                                                    _vm.options
                                                      .yellowIndicatorDays &&
                                                  _vm.daysBeforeDeadline(
                                                    task
                                                  ) >=
                                                    _vm.options.redIndicatorDays
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-clock-o"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.daysBeforeDeadline(task)
                                                  ) +
                                                  " jour" +
                                                  _vm._s(
                                                    _vm.daysBeforeDeadline(
                                                      task
                                                    ) == 1
                                                      ? ""
                                                      : "s"
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.comment_count > 0
                                        ? _c("span", { staticClass: "mr-2" }, [
                                            _c("i", {
                                              staticClass: "fa fa-comment-o"
                                            }),
                                            _vm._v(
                                              " " + _vm._s(task.comment_count)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.file_count > 0
                                        ? _c("span", { staticClass: "mr-2" }, [
                                            _c("i", {
                                              staticClass: "fa fa-paperclip"
                                            }),
                                            _vm._v(
                                              " " + _vm._s(task.file_count)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.task_progress > 0
                                        ? _c("span", { staticClass: "mr-2" }, [
                                            _c("i", {
                                              staticClass: "fa fa-percent"
                                            }),
                                            _vm._v(
                                              " " + _vm._s(task.task_progress)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.task_reminder
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mr-2 deadline-indicator deadline-danger"
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-bell"
                                              }),
                                              _vm._v(
                                                " Rappel\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      task.task_mentions > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mr-2 deadline-indicator deadline-danger"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      @ " +
                                                  _vm._s(task.task_mentions) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "pl-1 pr-2",
                                    staticStyle: {
                                      "white-space": "nowrap",
                                      width: "1%",
                                      "font-size": "11px",
                                      "text-align": "right",
                                      "font-family": "monospace"
                                    }
                                  },
                                  [
                                    task.task_start_date != null
                                      ? _c("div", [
                                          _vm._v(
                                            "Début: " +
                                              _vm._s(task.task_start_date)
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.task_deadline_date != null
                                      ? _c(
                                          "div",
                                          {
                                            class: {
                                              "font-red":
                                                _vm.daysBeforeDeadline(task) <=
                                                _vm.options.redIndicatorDays
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Échéance: " +
                                                _vm._s(task.task_deadline_date)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "bold font-blue pr-4 py-2",
                                    staticStyle: {
                                      "white-space": "nowrap",
                                      width: "1%"
                                    }
                                  },
                                  [_vm._v(_vm._s(task.task_state_name))]
                                ),
                                _vm._v(" "),
                                _c("td", {
                                  staticClass: "task-unread-indicator"
                                })
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                _vm._v(" "),
                _vm.loadingTasks
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "text-center p-3 font-grey-gallery" },
                        [
                          _c("img", {
                            staticStyle: {
                              height: "30px",
                              "margin-right": "10px"
                            },
                            attrs: { src: _vm.spinnerSVG }
                          }),
                          _vm._v(" Chargement des tâches...")
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "bg-grey h-100 position-absolute",
                staticStyle: { width: "2px", top: "0", right: "0" }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "task-manager-right-panel" }, [
            _vm.selectedTask !== null
              ? _c(
                  "div",
                  { staticClass: "h-100" },
                  [
                    !_vm.loadingSelectedTask
                      ? _c("task-details", {
                          ref: "task-detail",
                          attrs: {
                            task: _vm.selectedTask,
                            user: _vm.user,
                            states: _vm.states,
                            categories: _vm.categories
                          },
                          on: {
                            close: _vm.unselectTask,
                            deleted: _vm.taskDeleted,
                            toggleread: _vm.toggleTaskRead
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "h-100 d-flex align-items-center justify-content-center"
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                height: "30px",
                                "margin-right": "10px"
                              },
                              attrs: { src: _vm.spinnerSVG }
                            }),
                            _vm._v(" Chargement de la tâche...\n        ")
                          ]
                        )
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "h-100 d-flex align-items-center justify-content-center"
                  },
                  [_vm._v("\n        Veuillez sélectionner une tâche\n      ")]
                )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }